import classNames from 'classnames';
import React from 'react';

import s from './index.module.css';

const cx = classNames.bind(s);

const Loader = ({ className }) => (
  <div className={s.loaderWrapper}>
    <div className={cx(s.loader, { [className]: true })}>
      <span />
    </div>
  </div>
);

export default Loader;
